export default __webpack_public_path__ + "static/media/Snd_LowerWSlidedowna.7956ccdf.mp3";